import { apiUrl, apiOptions, handleResponse, handleError } from './apiUtils';

export interface SteamPackageModel {
  packageId: number;
  name: string;
}

export interface SteamAppModel {
  appId: number;
  title: string;
  packages: SteamPackageModel[];
}

const baseUrl = apiUrl + '/steam';

/**
 * Fetches Steam game details for the given comma-separated app IDs.
 */
export function getGames(appIds: string): Promise<SteamAppModel[]> {
  const params = new URLSearchParams({ appIds: appIds.trim() });
  const url = `${baseUrl}?${params.toString()}`;
  return fetch(url, apiOptions()).then(handleResponse).catch(handleError);
}
